import { Fragment, JSX } from 'react';

import { Show } from './Show';

interface For<T>
  extends Omit<React.ComponentProps<typeof Show>, 'children' | 'when'> {
  each: T[];
  children: (d: T, i: number) => JSX.Element;
}

export function For<T>({ each, children, ...showProps }: For<T>) {
  return (
    <Show when={each.length > 0} {...showProps}>
      {each.map((d, i) => (
        <Fragment key={i}>{children(d, i)}</Fragment>
      ))}
    </Show>
  );
}
